export const siteInfo = {
  name: '91网',
  tagline: '您值得信赖的综合服务平台',
  description: '91网提供丰富的资源与便捷的在线体验，涵盖软件工具、学习教程、影视娱乐、游戏专区、资源下载、技术资讯等多个领域。',
  url: 'https://91wang.com',
  email: 'support@91wang.com',
  foundingYear: 2015,
};

export const navItems = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];